import * as Constants from '@/constants'

export const isFuelMonitorV2 = apparatus => {
  if (!apparatus) {
    return false
  }

  if (apparatus.deviceType) {
    return apparatus.deviceType === Constants.TankUtilityLteDeviceTypeV2
  }

  // trying to account for as many different apparatus detail structures/types as possible
  const deviceType =
    apparatus.properties?.find(x => x.type === Constants.ApparatusPropertyDevice)?.value?.deviceType ??
    apparatus.devices?.[0]?.deviceType

  if (!deviceType) {
    return false
  }

  return deviceType === Constants.TankUtilityLteDeviceTypeV2
}

export const hasPartiallyEnrolledTank = apparatuses => {
  const tanks = apparatuses?.filter(apparatus => apparatus?.type === Constants.FuelTankApparatusType)
  for (const tank of tanks) {
    if (!tankHasAllProperties(tank)) {
      return true
    }
  }
  return false
}

export const tankHasAllProperties = tank => {
  if (!tank?.properties) return false
  const hasFuelType = tank.properties.find(x => x.name === 'FuelType')
  const hasOrientation = tank.properties.find(x => x.name === 'Orientation')
  const hasCapacity = tank.properties.find(x => x.name === 'Capacity')
  return hasFuelType && hasOrientation && hasCapacity
}
